export type Status =
    | 'angelegt'
    | 'erledigt'
    | 'erfüllt'
    | 'verzicht'
    | 'in Arbeit'
    | 'erhalten'
    | 'eingereicht'
    | 'offen'
    | 'storniert'
    | 'geplant'
    | 'ausgeführt';
type Label = 'done' | 'created' | 'not-required' | 'wip' | 'open' | 'error' | undefined;

const getStatusLabel = (status: Status): Label => {
    switch (status) {
        case 'angelegt':
            return 'created';
        case 'erfüllt':
        case 'erledigt':
            return 'done';

        case 'verzicht':
            return 'not-required';

        case 'in Arbeit':
        case 'eingereicht':
        case 'erhalten':
        case 'ausgeführt':
            return 'wip';

        case 'offen':
        case 'geplant':
            return 'open';

        case 'storniert':
            return 'error';

        default:
            return undefined;
    }
};

export default getStatusLabel;
